import * as fromDatatype from '../datatype-library/index';

export interface bl_b2b_payment_request_stmt_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_ocr_guid: fromDatatype.GuidDataFieldInterface;
    scanned_doc_no: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_code: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.VarcharDatatypeInterface;
    doc_reference_no: fromDatatype.VarcharDatatypeInterface;
    company_guid: fromDatatype.GuidDataFieldInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;
    company_name: fromDatatype.VarcharDatatypeInterface;
    amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    verification_status: fromDatatype.VarcharDatatypeInterface;
    confidence_level: fromDatatype.NumericDatatypeInterface;
    algorithm_provider: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;  
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_b2b_payment_request_stmt_hdr_RowClass implements bl_b2b_payment_request_stmt_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_ocr_guid: fromDatatype.GuidDataFieldInterface;
    scanned_doc_no: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_code: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.VarcharDatatypeInterface;
    doc_reference_no: fromDatatype.VarcharDatatypeInterface;
    company_guid: fromDatatype.GuidDataFieldInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;
    company_name: fromDatatype.VarcharDatatypeInterface;
    amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    verification_status: fromDatatype.VarcharDatatypeInterface;
    confidence_level: fromDatatype.NumericDatatypeInterface;
    algorithm_provider: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;  
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
